import welcomeScreen2 from 'Assets/Images/welcome-screen2.png';
import welcomeScreen3 from 'Assets/Images/welcome-screen3.png';
import welcomeScreen5 from 'Assets/Images/welcome-screen5.png';
import welcomeScreen6 from 'Assets/Images/welcome-screen6.png';
import welcomeScreen7 from 'Assets/Images/welcome-screen7.png';
import welcomeScreenQuestionMark from 'Assets/Images/welcome-screen-question-mark.png';
import FacetFacNegative from 'Assets/Images/facet_fac_negative.svg';

export const welcomeFlow = [
  {
    id: 'welcome',
    type: 'info',
    title: 'Welcome to Facet!',
    titleVariant: 'h1',
    text: 'The average adult makes 35,000 decisions a day. We\'re really glad you made this one to transform the way you live!',
    image: FacetFacNegative,
    imageWidth: 60,
    imageAlt: 'Facet logo',
    imageLocation: 'top',
    centered: true,
  },
  {
    id: 'cfp',
    type: 'info',
    title: 'Get ready to experience the best of both worlds with our human-plus-tech approach',
    titleVariant: 'h2',
    text: 'Along with CFP® Professionals who work with you, we have experts with various specialties to help with all of your financial needs and a secure, proprietary tech platform to streamline your financial life.',
    image: welcomeScreen2,
    imageAlt: 'Best of both worlds image',
    imageWidth: 280,
    imageLocation: 'top',
  },
  {
    id: 'financial-picture',
    type: 'info',
    titleVariant: 'h2',
    title: 'We\'ll help you get a complete financial picture of your life all in one place',
    text: 'Getting a total picture of your finances is a huge first step because it helps provide clarity, can illuminate quick wins, and can help turn procrastination into action.',
    image: welcomeScreen3,
    imageAlt: 'Graduation cap',
    imageWidth: 140,
    imageLocation: 'top',
  },
  {
    id: 'questions',
    type: 'picklist',
    title: 'Here\'s how it works',
    text: 'We\'ll ask you a series of questions about you, your money, and your money mindset (more on this later!). Every question you answer helps us uncover opportunities for you.',
    questionText: 'You will answer questions like this:',
    options: ['Sample Answer A', 'Sample Answer B', 'Sample Answer C'],
  },
  {
    id: 'navigation',
    type: 'info',
    title: 'Follow a path & track your progress',
    titleVariant: 'h1',
    text: 'We\'ll guide you from one section to the next (saving your work along the way), tracking your progress in case you need to step away before you\'re done. You can check on your progress at any time.',
    image: welcomeScreen5,
    imageAlt: 'Onboarding navigation demo',
    imageWidth: 240,
    imageLocation: 'bottom',
    navIconHighlighted: true,
  },
  {
    id: 'chat',
    type: 'info',
    title: 'Get help along the way',
    titleVariant: 'h1',
    text: 'Our support team is just one click away to answer any questions or address any issues you have as you navigate through the experience.',
    image: welcomeScreenQuestionMark,
    imageAlt: 'Question mark',
    imageWidth: 140,
    imageLocation: 'top',
    chatIconHighlighted: true,
  },
  {
    id: 'meeting',
    type: 'info',
    title: 'Schedule your 1st meeting with your planner',
    titleVariant: 'h1',
    text: 'Once you\'ve finished building your financial picture, the next step is to schedule your first meeting.',
    image: welcomeScreen6,
    imageAlt: 'Schedule first meeting demo',
    imageWidth: 240,
    imageLocation: 'bottom',
  },
  {
    id: 'lets-start',
    type: 'info',
    title: 'Let\'s start with the basics',
    titleVariant: 'h1',
    text: 'Building a profile for you and your family helps ensure we are building the most complete picture to get started.',
    image: welcomeScreen7,
    imageAlt: 'Group of people',
    imageWidth: 140,
    imageLocation: 'top',
    centered: true,
    nextButtonLabel: 'Get Started',
  },
];
